import { useEffect, useState } from 'react';
import {
  Calculator,
  CalculatorBox,
  CalculatorImage,
} from '../../DueDate/CalculatorBox/styled';
import OvulationResults from '../OvulationResults';
import OvulationCalculatorInputs from './OvulationCalculatorInputs';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function OvulationCalculatorBox(props) {
  let { heading, results, aplus, fromFaq } = props;
  const [resultData, setResultData] = useState({});

  useEffect(() => {
    fireServedSectionEvent(heading, '', 'Ovulation Calculator');
  }, []);

  return (
    <CalculatorBox aplus={aplus} results={results} ovulation>
      {!results && !fromFaq && (
        <div className="centerImage">
          <CalculatorImage
            src="/images/ovulationlogo.svg"
            width="60%"
            alt="logo"
          />
        </div>
      )}

      <Calculator results={results}>
        {!results && <h1>OVULATION CALCULATOR</h1>}
        {resultData.data ? (
          <OvulationResults
            resultData={resultData.data}
            selected={resultData.selected}
            setResultData={setResultData}
          />
        ) : (
          <OvulationCalculatorInputs
            results={aplus}
            setResultData={setResultData}
          />
        )}
      </Calculator>
    </CalculatorBox>
  );
}
